<template>
  <div class="fts-classification">
    <div
      class="locus-synchronize"
      :class="syncState"
      v-if="this.$store.state.needSync && !viewData"
    >
      <template v-if="syncState === 'locus-syncing'">
        <font-awesome-icon
          class="sync-icon"
          :icon="['fas', 'sync-alt']"
          fixed-width
          spin
        />
        <span class="sync-label">syncing...</span>
      </template>

      <template v-if="syncState === 'locus-synced'">
        <font-awesome-icon
          class="sync-icon"
          :icon="['far', 'check-circle']"
          fixed-width
        />
        <span class="sync-label">
          <a class="sync-btn" href="" @click.prevent="synchronize({})">sync</a>
          <fts-tippy
            class="sync-time"
            :content="moment(syncLastTime).format('llll')"
            :options="{ placement: 'top-end' }"
          >
            <div slot="trigger">{{ momentRelativeTime(syncLastTime) }}</div>
          </fts-tippy>
        </span>
      </template>

      <template v-if="syncState === 'locus-resync'">
        <font-awesome-icon
          class="sync-icon"
          :icon="['far', 'times-circle']"
          fixed-width
        />
        <span class="sync-label">
          <a class="sync-btn" href="" @click.prevent="synchronize({})">sync</a>
        </span>
      </template>
    </div>

    <fts-form
      :form="form"
      :formData="formData"
      :validator="$v.formData"
      :context="context"
      :vectorId="vectorId"
      :view="view"
      :username="username"
      @eventTriggered="triggerEvent"
      v-if="!comment.attention" />

    <template v-if="!view">
      <!-- <div class="classification-attention">
        <checkbox v-if="locusId" v-model="comment.attention" :color="'#279ec6'" :size="18">
          <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
          <div>Raise alert for this</div>
        </checkbox>
      </div> -->

      <fts-comment
        :vectorId="vectorId"
        :users="users"
        :comment="comment"
        class="classification-comment"
        v-if="commentSection"
      />

      <div class="classification-action">
        <fts-btn
          text
          :disabled="formLoading"
          @click.native.prevent="$emit('cancel')"
          v-if="!submitting"
        >
          <font-awesome-icon :icon="['fas', 'times']" />Cancel
        </fts-btn>

        <fts-btn
          color="primary"
          :disabled="formLoading"
          :loading="submitting"
          @click.native.prevent="submit"
        >
          <font-awesome-icon :icon="['fas', 'check']" />Done
        </fts-btn>
      </div>
    </template>
  </div>
</template>
<script>
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import _ from "lodash";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import moment from "moment";

import Avatar from "vue-avatar";
import Checkbox from "vue-material-checkbox";
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import VueJsonPretty from "vue-json-pretty";

import { classificationStore } from "../store/classificationStore";
import commons from "../commons/commons";

import FTSForm from "./FTSForm";
import FTSComment from "./FTSComment";
import FTSFormLayouter from "../design/FTSFormLayouter";
import FTSTippy from "../elements/FTSTippy";
import FTSBtn from "../elements/FTSBtn";

export default {
  props: {
    locusId: [String, Number],
    locusIds: String,
    vectorId: [String, Number],
    activityId: String,
    activity: String,
    users: Array,
    currentUsername: String,
    comment: {
      type: Object,
      default: () => ({}),
    },
    commentSection: {
      type: Boolean,
      default: true,
    },
    view: Boolean,
    submitting: Boolean,
    context: Object,
    username: String,
    viewData: Object,
  },
  data() {
    return {
      polling: null,
      selectedActivity: null,
    };
  },
  validations() {
    let formData = {};
    let elements = commons.getVisibleElements(null, this.form);
    // temp for visibilityScript
    elements = elements.filter(x => commons.formElementVisibility(x, this.formData));
    // end
    formData = commons.getFormValidators(elements);
    return { formData };
  },
  store: classificationStore,
  watch: {
    users() {
      this.$store.dispatch("setUsers", { users: this.users });
    },
  },
  components: {
    Avatar,
    Checkbox,
    VueJsonPretty,
    "fts-form": FTSForm,
    "fts-comment": FTSComment,
    "fts-tippy": FTSTippy,
    "fts-btn": FTSBtn,
  },
  computed: {
    formData: {
      get: function () {
        if(this.viewData)
          return this.viewData.formData;
        return this.$store.state.formData;
      },
    },
    form: {
      get: function () {
        if(this.viewData)
          return this.viewData.form;
        return this.$store.state.form;
      },
    },
    sync() {
      return this.$store.state.needSync;
    },
    syncLastTime() {
      return this.$store.state.syncLastTime;
    },
    syncState() {
      if (this.$store.state.synchronizing) return "locus-syncing";
      else if (this.$store.state.syncError) return "locus-resync";
      else return "locus-synced";
    },
    formLoading() {
      return this.$store.state.synchronizing;
    },
  },
  methods: {
    triggerEvent(eventName) {
      this.$store.dispatch("eventTriggered", {
        eventName: eventName,
        activity: this.selectedActivity
      });
    },
    moment,
    momentRelativeTime(date) {
      return commons.momentRelativeTime(date);
    },
    addToForm(cartItems) {
      if (this.formData[cartItems.fields[0].fieldName] == null) {
        Vue.set(this.formData, cartItems.fields[0].fieldName, []);
      }
      //find form field,
      let rows = this.formData[cartItems.fields[0].fieldName];
      cartItems.items.forEach((item) => {
        var row = {
          id: commons.newUUID(),
        };

        let fieldName = cartItems.fields[1].fieldName;
        let connectionFieldName = cartItems.fields[1].connectionFieldName;
        Vue.set(row, fieldName + "Id", item.id);
        Vue.set(row, fieldName, item.extension[connectionFieldName]);

        rows.push(row);
      });
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toasted.global.invalidFormValidate();
      } else {
        if (this.form && this.form.bds) {
          try {
            eval(this.form.bds);
          } catch (ex) {
            this.$toasted.error(ex);
            throw ex;
          }
        }

        this.$emit("submit", this.formData);
      }
    },
    synchronize(payload) {
      payload.view = this.view;
      payload.polling = this.polling;
      payload.activity = this.selectedActivity;
      this.$store.dispatch("synchronize", payload);
    },
    pollData(selectedActivity) {
      this.selectedActivity = selectedActivity;
      console.log("poll...");
      let vm = this;
      if (vm.polling) {
        console.log("clr poll" + vm.polling);
        clearInterval(vm.polling);
      }

      vm.polling = setInterval(() => {
        if (!vm.$store.getters.syncError) vm.synchronize({});
      }, 1500);
      this.$store.dispatch("polling", {
        polling: vm.polling,
      });
      console.log("crt poll: " + vm.polling);
    },
  },
  watch: {
    formData: {
      deep: true,
      handler() {
        console.log("formdata changed");
        let vm = this;
        _.debounce(function () {
          if (vm.$store.state.appliedChange) {
            vm.$store.dispatch("resetApplyChange");
          } else {
            vm.synchronize({});
          }
        }, 500);
      },
    },
  },
  beforeDestroy() {
    console.log("clr poll:" + this.polling);
    clearInterval(this.polling);
  },
  created() {
    this.$set(this.comment, "attention", false);
  },
  beforeCreate: function () {
    Vue.component("fts-form-layouter", FTSFormLayouter);
    Vue.component("fts-form", FTSForm);
  },
  async mounted() {
    let vm = this;
    this.$nextTick(() => {
      this.$v.$reset();
    });
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-classification {
  .classification-attention {
    display: flex;
    align-items: center;
    margin: 0 0.375rem;
    .m-chckbox--container {
      width: initial;
      .m-chckbox--label {
        display: inline-flex;
        align-items: center;
        padding-left: 0.75rem;
        font-size: 0.875rem;
        > svg {
          margin-right: 0.375rem;
        }
      }
    }
  }
  .classification-comment {
    margin: 0 0.375rem;
  }
  .classification-action {
    margin: 2rem 0.375rem 1rem;
    text-align: right;
  }
}

// Sync
.locus-synchronize {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px;
  font-size: 0.875rem;
  .sync-label {
    display: flex;
    align-items: center;
    margin-left: 0.375rem;
    color: var(--fts-gray-5);
    cursor: default;
    .sync-btn {
      text-decoration: none;
      color: $primaryColor;
    }
    .sync-time {
      margin-left: 0.275rem;
    }
  }
  &.locus-synced {
    .sync-icon {
      color: var(--fts-success);
    }
  }

  &.locus-syncing {
    .sync-icon {
      color: var(--fts-gray-5);
    }
  }
  &.locus-resync {
    .sync-icon {
      color: var(--fts-danger);
    }
  }
}

// Attention
// For Temporary fix. Not good to have
// Override v-modal class
// Fixed positioning issues v-modal with angularjs uib-modal
.modal-dialog {
  .ribbon-container.shotcut-activity {
    .v--modal-overlay {
      bottom: 0;
      height: auto;
      .v--modal-box.v--modal.vue-dialog {
        position: absolute;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
      }
    }
  }
}
</style>